import './vendor/payment-utils.js';
import './vendor/document-utils.js';
import { COMPANY } from './config.js';
import { request, vendey, unwrap, lookupCustomer, pipe, validateStock } from './api.js';
import { readJson, readSession } from './storage.js';
import { assertStock, sessionIdentity } from './sale.js';
import { notifyEvent } from './notifications.js';
import { logService } from './logs.js';
const PENDING_KEY = 'vendeySveltePending:' + COMPANY;
export const pendingEmission = () => readJson(PENDING_KEY);
export const documentRules = globalThis.VendeyDocumentos;
export const paymentRules = globalThis.VendeyPayment;
export function buildPayload({ items, client, session, documentType, payment, sellerCode, now = new Date().toISOString() }) {
  if (!items.length) throw new Error('Agrega productos antes de emitir.');
  const valid = documentRules.validarComprobante({ tipoVenta: documentType, tipoCliente: client.type, numero: client.document });
  if (!valid.valido) throw new Error(valid.mensaje);
  if (!client.name.trim()) throw new Error('Ingresa el nombre del cliente.');
  if (items.some(item => !(item.quantity > 0) || !(item.price >= 0) || !Number.isFinite(item.quantity * item.price))) throw new Error('La venta contiene cantidades o precios inválidos.');
  const total = Math.round(items.reduce((sum, item) => sum + item.quantity * item.price, 0) * 100) / 100;
  const summary = paymentRules.crearResumenPago({ totalVenta: total, montoPagado: payment.amount, vuelto: Math.round((payment.amount - total) * 100) / 100 });
  const fields = paymentRules.crearCamposEmision(summary);
  const paymentText = payment.description || payment.method;
  const details = items.map((item, i) => {
    const gross = item.quantity * item.price; const net = gross / 1.18;
    return { NCODEMPRESA: 1, NCODAGENCIA: 1, NCODFACTURA: 0, NTIPOITEM: 1, NITEM: i + 1,
      NCODPRODUCTO: item.id, CPRODUCTODESC: item.name, CCODLOTE: '', NCANTIDAD: item.quantity,
      CCODLISTAPRECIO: String(item.priceListId || session.priceListId || 1), CUNDMEDIDA: '', NVALUNI: net / item.quantity,
      NVALBRUTO: net, NIGV: gross - net, NVALORSINPROM: gross, NDSCTOPROM: 0, NVENTANETA: net,
      NDSCUNI: 0, NDSCTO: 0, NVENTATOTAL: gross, NCANTDESPACHADA: 0, NCANTPORDESPACHAR: item.quantity,
      COBSERVACIONES: '', CUSERCREA: 'admin', DFECHACREA: now, CUSERMODIFICA: '', DFECHAMODIFICA: now,
      CUSERELIMINA: '', DFECHAELIMINA: now, CLOCALHOST: '', CESTADO: 'A', CPRODUCTODESCLARGA: '',
      NPORCDSCTO: 0, NCANTDEVUELTA: 0, NCANTPORDEVOLVER: item.quantity, NVAL_UNI: item.price,
      NDSC_UNI: 0, CINCLUYEIGV: 1, CCHECKAFECTOIGV: 1 };
  });
  const host = localStorage.getItem('nombreticketera') || '';
  let printCode = documentType === '01' ? '1' : documentType === '03' ? '2' : '8';
  if (String(session.boxSelectionId) === '2') printCode = documentType === '01' ? '11' : documentType === '03' ? '10' : '8';
  return {
    token: COMPANY, CCONEXION: 'string', NCODEMPRESA: 1, CTELEFONO: client.phone || '', NPEDIDO: '0', CDIRECCION: client.address || '',
    NCODAGENCIA: 1, NCODFACTURA: 0, CCODDOCUMENTOIMP: printCode, CSERFACTURA: '001', CNUMFACTURA: '', DFECHAFACTURA: now,
    CCODCLIENTE: client.code, CNOMBRECLIENTE: client.name.trim(), CCODDOCCLIENTE: client.type, CNUMDOCCLIENTE: client.document,
    CCODSUCURSAL: '', CCODVEHICULO: '', CCODPEDIDO: '', CCODPERIODO: '130', CCODVENDEDOR: String(sellerCode),
    CCODALMACEN: String(session.warehouseId), CCODGUIAREMISION: '', CCODCONDICION: '03', CCODMONEDA: '1',
    NTOTALCANTIDAD: items.reduce((sum, item) => sum + item.quantity, 0), NTOTALBRUTO: total / 1.18, NDESCPORC: 0, NDESCUENTO: 0,
    NTOTALIGV: total - total / 1.18, NTOTALDSCTOPROM: 0, NTOTAL: total, CTOTALTEXTO: `Son : ${total.toFixed(2)} soles`, CESTADOFAC: '3',
    ...fields.cabecera, DFECHAVENCIMIENTO: now, NDETRACCION: 0, NMONTODETRACCION: 0, NRETENCION: 0, NMONTORETENCION: 0,
    NPERCEPCION: 0, NMONTOPERCEPCION: 0, NESTADODESPACHO: 0, COBSERVACIONES: payment.method,
    CUSERCREA: paymentText.toUpperCase(), DFECHACREA: now, CUSERMODIFICA: paymentText.toUpperCase(), DFECHAMODIFICA: now,
    CUSERELIMINA: '', DFECHAELIMINA: now, CLOCALHOST: host, CESTADO: 'A', COBSERVACIONES2: localStorage.getItem('nombredispositivo') || '',
    DetalleComprobante: details,
    PagoCabs: [{ NCODEMPRESA: '1', NCODAGENCIA: '1', NCODPAGO: '0', NITEM: '0', NTIPOPAGO: '1', CCODMONEDA: '1',
      NTIPOTARJETA: '0', CNROTARJETA: '0', CNROVOUCHER: '0', ...fields.pago, COBSERVACIONES: payment.method,
      CUSERCREA: 'admin', DFECHACREA: now, CUSERMODIFICA: 'admin', DFECHAMODIFICA: now, CUSERELIMINA: 'admin',
      DFECHAELIMINA: null, CLOCALHOST: host, CESTADO: 'A', NCODTIPOPAGO: '1', CCODCONCEPTO: '0', NCODCUENTA: '0', NCAJA: String(session.boxId) }]
  };
}
async function prepare(args) {
  buildPayload({ ...args, sellerCode: args.session.sellerId });
  const items = await Promise.all(args.items.map(async item => localStorage.getItem('validarStock') !== 'false' ? { ...item, ...await validateStock(item.id, args.session) } : { ...item, controlled: false }));
  assertStock(items);
  const client = { ...args.client };
  if (client.document === '88888888') client.code = 3;
  else {
    const result = await lookupCustomer(client.document, client.type);
    client.code = Number(result?.NCODCLIENTE);
    if (!(client.code > 0)) throw new Error('No se pudo resolver el código del cliente.');
  }
  let seller = await vendey('spVnt_obtenervendedorcaja', pipe([args.session.seller, '']));
  if (Array.isArray(seller)) seller = seller[0];
  if (seller && typeof seller === 'object') seller = seller.NCODVENDEDOR ?? seller.ncodvendedor ?? Object.values(seller)[0];
  if (typeof seller === 'string' && seller.includes('¬')) seller = seller.split('¬')[1]?.split('|')[0];
  const sellerCode = Number.parseInt(String(seller), 10);
  if (!(sellerCode > 0)) throw new Error('No se pudo resolver el vendedor de la caja.');
  return buildPayload({ ...args, items, client, sellerCode });
}
export async function emitSale(args) {
  if (pendingEmission()) throw new Error('Hay una emisión pendiente. Reintenta esa emisión antes de crear otra.');
  const payload = await prepare(args);
  const pending = { key: crypto.randomUUID(), payload, snapshot: args, createdAt: new Date().toISOString() };
  localStorage.setItem(PENDING_KEY, JSON.stringify(pending));
  return retryEmission();
}
export async function retryEmission() {
  const pending = pendingEmission();
  if (!pending) throw new Error('No hay emisión pendiente.');
  if (sessionIdentity(readSession()) !== sessionIdentity(pending.snapshot.session)) throw new Error('Esta emisión corresponde a otra caja o vendedor. Inicia sesión en la caja original para reintentar.');
  let response;
  try { response = await request('Vendey/EmitirV3', pending.payload, { timeout: 60000, headers: { 'Idempotency-Key': pending.key } }); }
  catch (error) {
    // Un rechazo explícito permite corregir datos; un fallo incierto conserva la clave.
    if (error.confirmedRejection) localStorage.removeItem(PENDING_KEY);
    throw error;
  }
  if (response.Exito !== true) throw new Error('No se confirmó la emisión. Consulta las ventas antes de repetirla.');
  let result = unwrap(response);
  if (typeof result === 'string') result = { NCODFACTURA: Number(result.match(/(?:^|-)\s*(\d+)\s*$/)?.[1]), COMPROBANTE: result };
  if (!(Number(result?.NCODFACTURA) > 0)) throw new Error('No se recibió el código de factura. Conservamos la emisión pendiente.');
  const receipt = { ...pending.snapshot, ...result, total: pending.payload.NTOTAL, createdAt: pending.createdAt };
  const history = readJson('vendeySvelteReceipts:' + COMPANY, []);
  localStorage.setItem('vendeySvelteReceipts:' + COMPANY, JSON.stringify([...history, receipt].slice(-100)));
  localStorage.removeItem(PENDING_KEY);
  notifyEvent('venta', receipt.session, { monto: receipt.total, numeroComprobante: receipt.NCODFACTURA, vendedor: receipt.session.seller }).catch(error => logService('Aviso de venta', error.message));
  Promise.resolve().then(() => vendey('spVnt_updatecliente', pipe([receipt.client.document, receipt.client.phone || '', receipt.client.address || '', '']))).catch(error => logService('Datos del cliente', error.message));
  return receipt;
}
